<template>
    <internal>
        <div
            class="p-6 bg-white border-b border-gray-200 shadow-sm sm:rounded-lg"
        >
            <p class="text-lg font-medium mb-4">Bulk ID's</p>
            <div class="grid grid-cols-3 gap-4">
                <div>
                    <FormMultiselect
                        required
                        label="Select Type"
                        :options="userTypeOptions"
                        track-key="id"
                        label-key="title"
                        :object="true"
                        v-model="userType"
                        :placeholder="'Select Type'"
                    />
                </div>
                <div v-if="userType?.id == 1">
                    <FormMultiselect
                        required
                        label="Select Course"
                        :options="courses"
                        track-key="id"
                        label-key="title"
                        :object="true"
                        v-model="selectCourse"
                        :placeholder="'Select Course'"
                    />
                </div>
                <div v-if="userType?.id == 1">
                    <FormMultiselect
                        required
                        label="Select Year"
                        :options="yearOptions"
                        track-key="id"
                        label-key="title"
                        :object="true"
                        v-model="selectYear"
                        :placeholder="'Select Year'"
                    />
                </div>
                <div class="flex items-end space-x-4 col-span-3">
                    <Button @click="viewDetails" class="py-3">View</Button>
                    <Button @click="downloadZip" class="py-3">Download</Button>
                </div>
            </div>

            <div v-if="userType?.id == 1" class="mt-4">
                <Table
                    :fields="[
                        { key: 'name', label: 'Name' },
                        { key: 'mobile', label: 'Mobile' },
                        { key: 'action', label: 'Id Present' },
                    ]"
                    :items="viewData"
                    :canView="true"
                >
                    <template #name="data">
                        {{ data.item.student?.first_name }}
                        {{ data.item.student?.middle_name }}
                        {{ data.item.student?.last_name }}
                    </template>
                    <template #action="data">
                        <TickIcon
                            v-if="data.item.student?.id_card"
                            class="text-green-600 h-5 w-5"
                        />
                        <Xicon v-else class="text-red-600 h-5 w-5" />
                    </template>
                    <template #mobile="data">
                        {{ data.item.student?.mobile }}
                    </template>
                </Table>
            </div>
            <div v-if="userType?.id == 2" class="mt-4">
                <Table
                    :fields="[
                        { key: 'name', label: 'Name' },
                        { key: 'mobile', label: 'Mobile' },
                        { key: 'action', label: 'Id Present' },
                    ]"
                    :items="viewData"
                    :canView="true"
                >
                    <template #name="data">
                        {{ data.item?.first_name }}
                        {{ data.item?.middle_name }}
                        {{ data.item?.last_name }}
                    </template>
                    <template #action="data">
                        <TickIcon
                            v-if="data.item.branches[0].pivot.id_card"
                            class="text-green-600 h-5 w-5"
                        />
                        <Xicon v-else class="text-red-600 h-5 w-5" />
                    </template>
                    <template #mobile="data">
                        {{ data.item?.mobile }}
                    </template>
                </Table>
            </div>

            <div v-if="userType?.id == 3" class="mt-4">
                <Table
                    :fields="[
                        { key: 'name', label: 'Name' },
                        { key: 'mobile', label: 'Mobile' },
                        { key: 'action', label: 'Id Present' },
                    ]"
                    :items="viewData"
                    :canView="true"
                >
                    <template #name="data">
                        {{ data.item?.name }}
                    </template>
                    <template #action="data">
                        <TickIcon
                            v-if="data.item.branches[0].pivot.id_card"
                            class="text-green-600 h-5 w-5"
                        />
                        <Xicon v-else class="text-red-600 h-5 w-5" />
                    </template>
                    <template #mobile="data">
                        {{ data.item?.mobile }}
                    </template>
                </Table>
            </div>
        </div>
    </internal>
</template>

<script setup>
import { computed, ref, watch } from "vue";
import Button from "@/Components/Button.vue";
import Table from "@/Components/Table.vue";
import Xicon from "@/Components/Icons/Xicon.vue";
import TickIcon from "@/Components/Icons/TickIcon.vue";
import FormMultiselect from "@/Components/Forms/FormMultiselect.vue";
import Internal from "@/Pages/Internal/Internal";
import { usePage } from "@inertiajs/inertia-vue3";

const props = defineProps({
    courses: Object,
    years: Object,
    branch: Object,
});
const branch_id = computed(() => props.branch.id);
const userType = ref("");
const userTypeOptions = [
    // {id: 0, title: 'select type of user', disable: true},
    { id: 1, title: "Student" },
    { id: 2, title: "Teacher" },
    { id: 3, title: "Staff" },
];

const selectCourse = ref([]);
const selectYear = ref([]);
const viewData = ref([]);
watch(userType, (_new, _old) => {
    viewData.value = [];
});

watch(selectCourse, (_new, _old) => {
    selectYear.value = [];
    viewData.value = [];
});

const yearOptions = computed(() => {
    if (!props.years) return [];
    if (!selectCourse.value?.id) return [];
    return props.years.filter((y) => y.course_id === selectCourse.value.id);
});

function downloadZip() {
    let course = "&course=" + (selectCourse.value?.id || "");
    let year = "&year=" + (selectYear.value?.id || "");
    window.open(
        route("internal.bulkIds.download.zip", { branch: branch_id.value }) +
            "?type=" +
            userType.value?.title +
            course +
            year,
        "_blank"
    );
}

function viewDetails() {
    window.axios
        .get(
            route("internal.bulkIds.download.checking", {
                branch: branch_id.value,
            }),
            {
                params: {
                    type: userType.value?.title,
                    course: selectCourse.value?.id,
                    year: selectYear.value?.id,
                },
            }
        )
        .then((resp) => {
            viewData.value = resp.data;
        });
}

function makeBlob(data) {
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "test.zip"); //or any other extension
    document.body.appendChild(link);
    link.click();
}
</script>
